import {useTheme, TextField} from "@mui/material";
import {styled} from "@mui/material/styles";

const StyledTextField = styled(TextField)(({theme, variant, multiline}) => ({
    ...(variant === "outlined" && {
        '& .MuiOutlinedInput-root': {
            borderRadius: "4px", 
            ...(multiline ? {} : {height: "42px"}),

            '& input': {
                color: theme.typography.main,
                fontSize: 16,
                fontWeight: 500,

                '&::placeholder': {
                    color: theme.typography.secondary,               
                    opacity: 0.45,    
                    fontSize: 15,    
                    fontWeight: "400 !important",                     
                },
            },

            '& fieldset': {
                borderColor: "#e5edf6",
            },
            '&:hover fieldset': {
                borderColor: "#e5edf6",
            },
            '&.Mui-focused fieldset': {
                borderColor: "#253e5a9e",
            },
        },
    }),

    ...(variant === "filled" && {
        '& .MuiFilledInput-root': {
            borderRadius: "2px",

            '&:hover': {
                // 
            },

            '&.Mui-focused': {
                //, 
            },

            '&:before': {
                borderBottom: "none", 
            },
            '&:after': {
                borderBottom: "none",
            },
        },
        '& .MuiFilledInput-underline:before': {
            borderBottom: "none",
        },
        '& .MuiFilledInput-underline:after': {
            borderBottom: "none",
        },
        '&.Mui-focused .MuiFilledInput-underline:after': {
            borderBottom: "none",
        },
    }),
    '& .MuiFormHelperText-root': {
        color: 'red',
        fontSize: 11,
        marginLeft: 2,
    },
}));

const CustomTextField = ({placeholder, variant, label, onChange, value, rows, multiline, hiddenLabel, fullWidth, customStyles, readOnly, allowedPattern, ...props}) => {
    const theme = useTheme();

    // Function to filter out special characters
    const handleInputChange = (e) => {
        let filteredValue = e.target.value;
        if (allowedPattern instanceof RegExp) {
            filteredValue = e.target.value.replace(allowedPattern, '');
            filteredValue = filteredValue.replace(/\.+/g, '.').replace(/-+/g, '-');
        }
        if (onChange) {
            onChange({
                ...e,
                target: {
                ...e.target,
                value: filteredValue,
                },
            });
        }
    };

    return (
        <StyledTextField 
            placeholder={placeholder}
            variant={variant}  
            label={label}
            onChange={handleInputChange}
            value={value}
            rows={rows} 
            multiline={multiline}
            fullWidth={fullWidth}
            hiddenLabel={hiddenLabel}
            sx={{
                ...customStyles 
            }} 
            slotProps={{
                input: {
                    readOnly: readOnly ? readOnly : false,
                    disableUnderline: variant === "filled"
                },
            }}
            {...props}
        >
        </StyledTextField>
    );  
}

export default CustomTextField
